import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '../Query';
import { ScheduledNotificationEndpoint } from '@api/endpoints';

export class ScheduledNotificationApi {
  static create (
    body: ScheduledNotificationEndpoint.Create.Request,
  ): Promise<ScheduledNotificationEndpoint.Create.Response> {
    return Client('scheduled-notifications', {
      method: 'POST',
      body,
    });
  }

  static get (id: string): Promise<ScheduledNotificationEndpoint.Get.Response> {
    return Client(`scheduled-notifications/${id}`);
  }

  static list (
    query: ScheduledNotificationEndpoint.List.QueryParams,
  ): Promise<ScheduledNotificationEndpoint.List.Response> {
    const queryString = QueryUtil.stringify(query);
    return Client(`scheduled-notifications?${queryString}`);
  }

  static update (
    id: string,
    body: ScheduledNotificationEndpoint.Update.Request,
  ): Promise<ScheduledNotificationEndpoint.Update.Response> {
    return Client(`scheduled-notifications/${id}`, {
      method: 'PATCH',
      body,
    });
  }

  static delete (id: string): Promise<void> {
    return Client(`scheduled-notifications/${id}`, { method: 'DELETE' });
  }

  static getRecipientsCount (
    payload: ScheduledNotificationEndpoint.GetRecipients.Query,
  ): Promise<ScheduledNotificationEndpoint.GetRecipients.CountResponse> {
    return Client(`scheduled-notifications/get-recipients-count`, {
      method: 'POST',
      body: payload,
    });
  }

  static getRecipientsFromCsv (
    payload: FormData,
  ): Promise<ScheduledNotificationEndpoint.RecipientsFromCsv.Response> {
    return Client(`scheduled-notifications/recipients-from-csv`, {
      method: 'POST',
      body: payload,
    });
  }

  static getStats (id: string): Promise<ScheduledNotificationEndpoint.GetStats.Response> {
    return Client(`scheduled-notifications/${id}/stats`);
  }

  static getRecipients (
    body: ScheduledNotificationEndpoint.GetRecipients.Query,
  ): Promise<ScheduledNotificationEndpoint.GetRecipients.Response> {
    return Client(`scheduled-notifications/get-recipients`, {
      method: 'POST',
      body,
    });
  }

  static getRecipientFilters (
    body: ScheduledNotificationEndpoint.GetRecipientFilters.Request,
  ): Promise<ScheduledNotificationEndpoint.GetRecipientFilters.Response> {
    return Client('scheduled-notifications/get-recipient-filters', {
      method: 'POST',
      body,
    });
  }

  static exportRecipient (
    body?: ScheduledNotificationEndpoint.GetRecipients.Query,
    id?: string | null,
  ): Promise<string> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return Client(`scheduled-notifications/${id}/recipients-export`, {
      method: 'POST',
      body,
      headers: {
        'X-Timezone': timeZone,
      },
    });
  }

  static validateInsertVariables (
    body: ScheduledNotificationEndpoint.ValidateInsertVariables.Request,
  ): Promise<ScheduledNotificationEndpoint.ValidateInsertVariables.Response> {
    return Client('scheduled-notifications/validate', {
      method: 'POST',
      body,
    });
  }

  static previewMessage (
    body: ScheduledNotificationEndpoint.PreviewMessage.Request,
  ): Promise<ScheduledNotificationEndpoint.PreviewMessage.Response> {
    return Client('scheduled-notifications/preview-message', {
      method: 'POST',
      body,
    });
  }
}
